export const InventoryItemInfos = [
  {
    itemId: 0,
    categoryId: 0,
    typeId: 0,
    categoryName: "Cash",
    typeName: "50000",
    chance1: 20,
    chance2: 28,
    inventoryWorth: 5,
  },
  {
    itemId: 1,
    categoryId: 0,
    typeId: 1,
    categoryName: "Cash",
    typeName: "150000",
    chance1: 20,
    chance2: 18,
    inventoryWorth: 15,
  },
  {
    itemId: 2,
    categoryId: 0,
    typeId: 2,
    categoryName: "Cash",
    typeName: "250000",
    chance1: 20,
    chance2: 15,
    inventoryWorth: 25,
  },
  {
    itemId: 3,
    categoryId: 0,
    typeId: 3,
    categoryName: "Cash",
    typeName: "350000",
    chance1: 20,
    chance2: 12,
    inventoryWorth: 35,
  },
  {
    itemId: 4,
    categoryId: 0,
    typeId: 4,
    categoryName: "Cash",
    typeName: "500000",
    chance1: 20,
    chance2: 9,
    inventoryWorth: 50,
  },
  {
    itemId: 5,
    categoryId: 0,
    typeId: 5,
    categoryName: "Cash",
    typeName: "1000000",
    chance1: 20,
    chance2: 7,
    inventoryWorth: 100,
  },
  {
    itemId: 6,
    categoryId: 0,
    typeId: 6,
    categoryName: "Cash",
    typeName: "2500000",
    chance1: 20,
    chance2: 5,
    inventoryWorth: 250,
  },
  {
    itemId: 7,
    categoryId: 0,
    typeId: 7,
    categoryName: "Cash",
    typeName: "4000000",
    chance1: 20,
    chance2: 3,
    inventoryWorth: 400,
  },
  {
    itemId: 8,
    categoryId: 0,
    typeId: 8,
    categoryName: "Cash",
    typeName: "5000000",
    chance1: 20,
    chance2: 2,
    inventoryWorth: 500,
  },
  {
    itemId: 9,
    categoryId: 0,
    typeId: 9,
    categoryName: "Cash",
    typeName: "10000000",
    chance1: 20,
    chance2: 1,
    inventoryWorth: 1000,
  },
  {
    itemId: 10,
    categoryId: 1,
    typeId: 0,
    categoryName: "Bullets",
    typeName: "250",
    chance1: 10,
    chance2: 28,
    inventoryWorth: 25,
  },
  {
    itemId: 11,
    categoryId: 1,
    typeId: 1,
    categoryName: "Bullets",
    typeName: "500",
    chance1: 10,
    chance2: 18,
    inventoryWorth: 50,
  },
  {
    itemId: 12,
    categoryId: 1,
    typeId: 2,
    categoryName: "Bullets",
    typeName: "750",
    chance1: 10,
    chance2: 15,
    inventoryWorth: 75,
  },
  {
    itemId: 13,
    categoryId: 1,
    typeId: 3,
    categoryName: "Bullets",
    typeName: "1500",
    chance1: 10,
    chance2: 12,
    inventoryWorth: 150,
  },
  {
    itemId: 14,
    categoryId: 1,
    typeId: 4,
    categoryName: "Bullets",
    typeName: "3500",
    chance1: 10,
    chance2: 9,
    inventoryWorth: 350,
  },
  {
    itemId: 15,
    categoryId: 1,
    typeId: 5,
    categoryName: "Bullets",
    typeName: "5000",
    chance1: 10,
    chance2: 7,
    inventoryWorth: 500,
  },
  {
    itemId: 16,
    categoryId: 1,
    typeId: 6,
    categoryName: "Bullets",
    typeName: "7000",
    chance1: 10,
    chance2: 5,
    inventoryWorth: 700,
  },
  {
    itemId: 17,
    categoryId: 1,
    typeId: 7,
    categoryName: "Bullets",
    typeName: "15000",
    chance1: 10,
    chance2: 3,
    inventoryWorth: 1500,
  },
  {
    itemId: 18,
    categoryId: 1,
    typeId: 8,
    categoryName: "Bullets",
    typeName: "20000",
    chance1: 10,
    chance2: 2,
    inventoryWorth: 2000,
  },
  {
    itemId: 19,
    categoryId: 1,
    typeId: 9,
    categoryName: "Bullets",
    typeName: "30000",
    chance1: 10,
    chance2: 1,
    inventoryWorth: 3000,
  },
  {
    itemId: 20,
    categoryId: 2,
    typeId: 0,
    categoryName: "Health",
    typeName: "50",
    chance1: 15,
    chance2: 28,
    inventoryWorth: 100,
  },
  {
    itemId: 21,
    categoryId: 2,
    typeId: 1,
    categoryName: "Health",
    typeName: "100",
    chance1: 15,
    chance2: 18,
    inventoryWorth: 200,
  },
  {
    itemId: 22,
    categoryId: 2,
    typeId: 2,
    categoryName: "Health",
    typeName: "150",
    chance1: 15,
    chance2: 15,
    inventoryWorth: 300,
  },
  {
    itemId: 23,
    categoryId: 2,
    typeId: 3,
    categoryName: "Health",
    typeName: "200",
    chance1: 15,
    chance2: 12,
    inventoryWorth: 400,
  },
  {
    itemId: 24,
    categoryId: 2,
    typeId: 4,
    categoryName: "Health",
    typeName: "250",
    chance1: 15,
    chance2: 3,
    inventoryWorth: 500,
  },
  {
    itemId: 25,
    categoryId: 2,
    typeId: 5,
    categoryName: "Health",
    typeName: "300",
    chance1: 15,
    chance2: 7,
    inventoryWorth: 600,
  },
  {
    itemId: 26,
    categoryId: 2,
    typeId: 6,
    categoryName: "Health",
    typeName: "350",
    chance1: 15,
    chance2: 5,
    inventoryWorth: 700,
  },
  {
    itemId: 27,
    categoryId: 2,
    typeId: 7,
    categoryName: "Health",
    typeName: "500",
    chance1: 15,
    chance2: 3,
    inventoryWorth: 1000,
  },
  {
    itemId: 28,
    categoryId: 2,
    typeId: 8,
    categoryName: "Health",
    typeName: "750",
    chance1: 15,
    chance2: 2,
    inventoryWorth: 1500,
  },
  {
    itemId: 29,
    categoryId: 2,
    typeId: 9,
    categoryName: "Health",
    typeName: "1000",
    chance1: 15,
    chance2: 1,
    inventoryWorth: 2000,
  },
  {
    itemId: 30,
    categoryId: 3,
    typeId: 0,
    categoryName: "Shop item",
    typeName: "Hand Gun Colt 1911",
    chance1: 20,
    chance2: 15,
    inventoryWorth: 5,
  },
  {
    itemId: 31,
    categoryId: 3,
    typeId: 1,
    categoryName: "Shop item",
    typeName: "Remington model 870",
    chance1: 20,
    chance2: 15,
    inventoryWorth: 15,
  },
  {
    itemId: 32,
    categoryId: 3,
    typeId: 2,
    categoryName: "Shop item",
    typeName: "Thompson 1928",
    chance1: 20,
    chance2: 14,
    inventoryWorth: 24,
  },
  {
    itemId: 33,
    categoryId: 3,
    typeId: 3,
    categoryName: "Shop item",
    typeName: "Molotov cocktail",
    chance1: 20,
    chance2: 12,
    inventoryWorth: 35,
  },
  {
    itemId: 34,
    categoryId: 3,
    typeId: 4,
    categoryName: "Shop item",
    typeName: "Grenade",
    chance1: 20,
    chance2: 11,
    inventoryWorth: 50,
  },
  {
    itemId: 35,
    categoryId: 3,
    typeId: 5,
    categoryName: "Shop item",
    typeName: "Motorcycle",
    chance1: 20,
    chance2: 10,
    inventoryWorth: 100,
  },
  {
    itemId: 36,
    categoryId: 3,
    typeId: 6,
    categoryName: "Shop item",
    typeName: "Bullet proof vest",
    chance1: 20,
    chance2: 8,
    inventoryWorth: 250,
  },
  {
    itemId: 37,
    categoryId: 3,
    typeId: 7,
    categoryName: "Shop item",
    typeName: "Bullet proof suit",
    chance1: 20,
    chance2: 7,
    inventoryWorth: 500,
  },
  {
    itemId: 38,
    categoryId: 3,
    typeId: 8,
    categoryName: "Shop item",
    typeName: "Armored car",
    chance1: 20,
    chance2: 5,
    inventoryWorth: 750,
  },
  {
    itemId: 39,
    categoryId: 3,
    typeId: 9,
    categoryName: "Shop item",
    typeName: "Douglas M-3",
    chance1: 20,
    chance2: 3,
    inventoryWorth: 850,
  },
  {
    itemId: 40,
    categoryId: 4,
    typeId: 0,
    categoryName: "Business objects",
    typeName: "Car crusher",
    chance1: 2,
    chance2: 17,
    inventoryWorth: 1500,
  },
  {
    itemId: 41,
    categoryId: 4,
    typeId: 1,
    categoryName: "Business objects",
    typeName: "Shop owner",
    chance1: 2,
    chance2: 17,
    inventoryWorth: 5000,
  },
  {
    itemId: 42,
    categoryId: 4,
    typeId: 2,
    categoryName: "Business objects",
    typeName: "Bank",
    chance1: 2,
    chance2: 16,
    inventoryWorth: 3000,
  },
  {
    itemId: 43,
    categoryId: 4,
    typeId: 3,
    categoryName: "Business objects",
    typeName: "Hospital",
    chance1: 2,
    chance2: 16,
    inventoryWorth: 5000,
  },
  {
    itemId: 44,
    categoryId: 4,
    typeId: 4,
    categoryName: "Business objects",
    typeName: "Detective Agency",
    chance1: 2,
    chance2: 12,
    inventoryWorth: 2000,
  },
  {
    itemId: 45,
    categoryId: 4,
    typeId: 5,
    categoryName: "Business objects",
    typeName: "Booze warehouse",
    chance1: 2,
    chance2: 8,
    inventoryWorth: 8000,
  },
  {
    itemId: 46,
    categoryId: 4,
    typeId: 6,
    categoryName: "Business objects",
    typeName: "Narcotics warehouse",
    chance1: 2,
    chance2: 6,
    inventoryWorth: 8000,
  },
  {
    itemId: 47,
    categoryId: 4,
    typeId: 7,
    categoryName: "Business objects",
    typeName: "Slotmachine",
    chance1: 2,
    chance2: 3,
    inventoryWorth: 9500,
  },
  {
    itemId: 48,
    categoryId: 4,
    typeId: 8,
    categoryName: "Business objects",
    typeName: "Roulette",
    chance1: 2,
    chance2: 3,
    inventoryWorth: 11000,
  },
  {
    itemId: 49,
    categoryId: 4,
    typeId: 9,
    categoryName: "Business objects",
    typeName: "Bullet factory\r\n",
    chance1: 2,
    chance2: 2,
    inventoryWorth: 15000,
  },
  {
    itemId: 50,
    categoryId: 5,
    typeId: 0,
    categoryName: "Bodyguards",
    typeName: "Lvl 3 - Johnny",
    chance1: 12,
    chance2: 10,
    inventoryWorth: 100,
  },
  {
    itemId: 51,
    categoryId: 5,
    typeId: 1,
    categoryName: "Bodyguards",
    typeName: "Lvl 3 - Jim",
    chance1: 12,
    chance2: 10,
    inventoryWorth: 150,
  },
  {
    itemId: 52,
    categoryId: 5,
    typeId: 2,
    categoryName: "Bodyguards",
    typeName: "Lvl 3 - Sam",
    chance1: 12,
    chance2: 10,
    inventoryWorth: 200,
  },
  {
    itemId: 53,
    categoryId: 5,
    typeId: 3,
    categoryName: "Bodyguards",
    typeName: "Lvl 5 - Johnny",
    chance1: 12,
    chance2: 20,
    inventoryWorth: 300,
  },
  {
    itemId: 54,
    categoryId: 5,
    typeId: 4,
    categoryName: "Bodyguards",
    typeName: "Lvl 6 - Jim",
    chance1: 12,
    chance2: 20,
    inventoryWorth: 400,
  },
  {
    itemId: 55,
    categoryId: 5,
    typeId: 5,
    categoryName: "Bodyguards",
    typeName: "Lvl 6 - Sam",
    chance1: 12,
    chance2: 10,
    inventoryWorth: 600,
  },
  {
    itemId: 56,
    categoryId: 5,
    typeId: 6,
    categoryName: "Bodyguards",
    typeName: "Lvl 7 - Frank",
    chance1: 12,
    chance2: 10,
    inventoryWorth: 1000,
  },
  {
    itemId: 57,
    categoryId: 5,
    typeId: 7,
    categoryName: "Bodyguards",
    typeName: "Lvl 8 - Johnny",
    chance1: 12,
    chance2: 5,
    inventoryWorth: 1500,
  },
  {
    itemId: 58,
    categoryId: 5,
    typeId: 8,
    categoryName: "Bodyguards",
    typeName: "Lvl 10 - Sam",
    chance1: 12,
    chance2: 4,
    inventoryWorth: 2000,
  },
  {
    itemId: 59,
    categoryId: 5,
    typeId: 9,
    categoryName: "Bodyguards",
    typeName: "Lvl 10 - Frank",
    chance1: 12,
    chance2: 1,
    inventoryWorth: 2500,
  },
  {
    itemId: 60,
    categoryId: 6,
    typeId: 0,
    categoryName: "Helper credits",
    typeName: "100",
    chance1: 4,
    chance2: 10,
    inventoryWorth: 10,
  },
  {
    itemId: 61,
    categoryId: 6,
    typeId: 1,
    categoryName: "Helper credits",
    typeName: "250",
    chance1: 4,
    chance2: 10,
    inventoryWorth: 25,
  },
  {
    itemId: 62,
    categoryId: 6,
    typeId: 2,
    categoryName: "Helper credits",
    typeName: "500",
    chance1: 4,
    chance2: 10,
    inventoryWorth: 50,
  },
  {
    itemId: 63,
    categoryId: 6,
    typeId: 3,
    categoryName: "Helper credits",
    typeName: "1000",
    chance1: 4,
    chance2: 20,
    inventoryWorth: 100,
  },
  {
    itemId: 64,
    categoryId: 6,
    typeId: 4,
    categoryName: "Helper credits",
    typeName: "1500",
    chance1: 4,
    chance2: 20,
    inventoryWorth: 150,
  },
  {
    itemId: 65,
    categoryId: 6,
    typeId: 5,
    categoryName: "Helper credits",
    typeName: "2000",
    chance1: 4,
    chance2: 10,
    inventoryWorth: 200,
  },
  {
    itemId: 66,
    categoryId: 6,
    typeId: 6,
    categoryName: "Helper credits",
    typeName: "2500",
    chance1: 4,
    chance2: 10,
    inventoryWorth: 250,
  },
  {
    itemId: 67,
    categoryId: 6,
    typeId: 7,
    categoryName: "Helper credits",
    typeName: "3000",
    chance1: 4,
    chance2: 5,
    inventoryWorth: 300,
  },
  {
    itemId: 68,
    categoryId: 6,
    typeId: 8,
    categoryName: "Helper credits",
    typeName: "3500",
    chance1: 4,
    chance2: 4,
    inventoryWorth: 350,
  },
  {
    itemId: 69,
    categoryId: 6,
    typeId: 9,
    categoryName: "Helper credits",
    typeName: "5000",
    chance1: 4,
    chance2: 1,
    inventoryWorth: 500,
  },
  {
    itemId: 70,
    categoryId: 7,
    typeId: 0,
    categoryName: "Car",
    typeName: "5000",
    chance1: 17,
    chance2: 10,
    inventoryWorth: 20,
  },
  {
    itemId: 71,
    categoryId: 7,
    typeId: 1,
    categoryName: "Car",
    typeName: "15000",
    chance1: 17,
    chance2: 10,
    inventoryWorth: 50,
  },
  {
    itemId: 72,
    categoryId: 7,
    typeId: 2,
    categoryName: "Car",
    typeName: "35000",
    chance1: 17,
    chance2: 10,
    inventoryWorth: 100,
  },
  {
    itemId: 73,
    categoryId: 7,
    typeId: 3,
    categoryName: "Car",
    typeName: "75000",
    chance1: 17,
    chance2: 20,
    inventoryWorth: 150,
  },
  {
    itemId: 74,
    categoryId: 7,
    typeId: 4,
    categoryName: "Car",
    typeName: "100000",
    chance1: 17,
    chance2: 20,
    inventoryWorth: 200,
  },
  {
    itemId: 75,
    categoryId: 7,
    typeId: 5,
    categoryName: "Car",
    typeName: "150000",
    chance1: 17,
    chance2: 10,
    inventoryWorth: 250,
  },
  {
    itemId: 76,
    categoryId: 7,
    typeId: 6,
    categoryName: "Car",
    typeName: "250000",
    chance1: 17,
    chance2: 10,
    inventoryWorth: 450,
  },
  {
    itemId: 77,
    categoryId: 7,
    typeId: 7,
    categoryName: "Car",
    typeName: "350000",
    chance1: 17,
    chance2: 5,
    inventoryWorth: 500,
  },
  {
    itemId: 78,
    categoryId: 7,
    typeId: 8,
    categoryName: "Car",
    typeName: "450000",
    chance1: 17,
    chance2: 4,
    inventoryWorth: 550,
  },
  {
    itemId: 79,
    categoryId: 7,
    typeId: 9,
    categoryName: "Car",
    typeName: "500000",
    chance1: 17,
    chance2: 1,
    inventoryWorth: 600,
  },
  {
    itemId: 80,
    categoryId: 8,
    typeId: 0,
    categoryName: "Wrapped Item",
    typeName: "Wrapped Key",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 150,
  },
  {
    itemId: 81,
    categoryId: 8,
    typeId: 1,
    categoryName: "Wrapped Item",
    typeName: "Wrapped OG NFT",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 1500,
  },
  {
    itemId: 90,
    categoryId: 9,
    typeId: 0,
    categoryName: "Key Item",
    typeName: "1",
    chance1: 5,
    chance2: 20,
    inventoryWorth: 150,
  },
  {
    itemId: 91,
    categoryId: 9,
    typeId: 1,
    categoryName: "Key Item",
    typeName: "3",
    chance1: 5,
    chance2: 20,
    inventoryWorth: 450,
  },
  {
    itemId: 92,
    categoryId: 9,
    typeId: 2,
    categoryName: "Key Item",
    typeName: "5",
    chance1: 5,
    chance2: 14,
    inventoryWorth: 750,
  },
  {
    itemId: 93,
    categoryId: 9,
    typeId: 3,
    categoryName: "Key Item",
    typeName: "7",
    chance1: 5,
    chance2: 12,
    inventoryWorth: 1050,
  },
  {
    itemId: 94,
    categoryId: 9,
    typeId: 4,
    categoryName: "Key Item",
    typeName: "10",
    chance1: 5,
    chance2: 11,
    inventoryWorth: 1500,
  },
  {
    itemId: 95,
    categoryId: 9,
    typeId: 5,
    categoryName: "Key Item",
    typeName: "15",
    chance1: 5,
    chance2: 10,
    inventoryWorth: 2250,
  },
  {
    itemId: 96,
    categoryId: 9,
    typeId: 6,
    categoryName: "Key Item",
    typeName: "25",
    chance1: 5,
    chance2: 8,
    inventoryWorth: 3750,
  },
  {
    itemId: 97,
    categoryId: 9,
    typeId: 7,
    categoryName: "Key Item",
    typeName: "50",
    chance1: 5,
    chance2: 3,
    inventoryWorth: 7500,
  },
  {
    itemId: 98,
    categoryId: 9,
    typeId: 8,
    categoryName: "Key Item",
    typeName: "75",
    chance1: 5,
    chance2: 1,
    inventoryWorth: 11250,
  },
  {
    itemId: 99,
    categoryId: 9,
    typeId: 9,
    categoryName: "Key Item",
    typeName: "100",
    chance1: 5,
    chance2: 1,
    inventoryWorth: 15000,
  },
  {
    itemId: 100,
    categoryId: 10,
    typeId: 0,
    categoryName: "Wrapped Mafia",
    typeName: "10000",
    chance1: 5,
    chance2: 22,
    inventoryWorth: 4.5,
  },
  {
    itemId: 101,
    categoryId: 10,
    typeId: 1,
    categoryName: "Wrapped Mafia",
    typeName: "15000",
    chance1: 5,
    chance2: 20,
    inventoryWorth: 6.75,
  },
  {
    itemId: 102,
    categoryId: 10,
    typeId: 2,
    categoryName: "Wrapped Mafia",
    typeName: "20000",
    chance1: 5,
    chance2: 17,
    inventoryWorth: 9,
  },
  {
    itemId: 103,
    categoryId: 10,
    typeId: 3,
    categoryName: "Wrapped Mafia",
    typeName: "30000",
    chance1: 5,
    chance2: 14,
    inventoryWorth: 13.5,
  },
  {
    itemId: 104,
    categoryId: 10,
    typeId: 4,
    categoryName: "Wrapped Mafia",
    typeName: "50000",
    chance1: 5,
    chance2: 11,
    inventoryWorth: 22.5,
  },
  {
    itemId: 105,
    categoryId: 10,
    typeId: 5,
    categoryName: "Wrapped Mafia",
    typeName: "100000",
    chance1: 5,
    chance2: 10,
    inventoryWorth: 45,
  },
  {
    itemId: 106,
    categoryId: 10,
    typeId: 6,
    categoryName: "Wrapped Mafia",
    typeName: "250000",
    chance1: 5,
    chance2: 3,
    inventoryWorth: 112.5,
  },
  {
    itemId: 107,
    categoryId: 10,
    typeId: 7,
    categoryName: "Wrapped Mafia",
    typeName: "500000",
    chance1: 5,
    chance2: 1,
    inventoryWorth: 225,
  },
  {
    itemId: 108,
    categoryId: 10,
    typeId: 8,
    categoryName: "Wrapped Mafia",
    typeName: "1000000",
    chance1: 5,
    chance2: 1,
    inventoryWorth: 450,
  },
  {
    itemId: 109,
    categoryId: 10,
    typeId: 9,
    categoryName: "Wrapped Mafia",
    typeName: "5000000",
    chance1: 5,
    chance2: 1,
    inventoryWorth: 2250,
  },
  {
    itemId: 110,
    categoryId: 11,
    typeId: 0,
    categoryName: "Wrapped OGNFT",
    typeName: "1",
    chance1: 2,
    chance2: 0,
    inventoryWorth: 750,
  },
  {
    itemId: 111,
    categoryId: 11,
    typeId: 1,
    categoryName: "Wrapped OGNFT",
    typeName: "1",
    chance1: 2,
    chance2: 0,
    inventoryWorth: 750,
  },
  {
    itemId: 112,
    categoryId: 11,
    typeId: 2,
    categoryName: "Wrapped OGNFT",
    typeName: "1",
    chance1: 2,
    chance2: 0,
    inventoryWorth: 750,
  },
  {
    itemId: 113,
    categoryId: 11,
    typeId: 3,
    categoryName: "Wrapped OGNFT",
    typeName: "1",
    chance1: 2,
    chance2: 0,
    inventoryWorth: 750,
  },
  {
    itemId: 114,
    categoryId: 11,
    typeId: 4,
    categoryName: "Wrapped OGNFT",
    typeName: "1",
    chance1: 2,
    chance2: 0,
    inventoryWorth: 750,
  },
  {
    itemId: 115,
    categoryId: 11,
    typeId: 5,
    categoryName: "Wrapped OGNFT",
    typeName: "3",
    chance1: 2,
    chance2: 0,
    inventoryWorth: 2250,
  },
  {
    itemId: 116,
    categoryId: 11,
    typeId: 6,
    categoryName: "Wrapped OGNFT",
    typeName: "3",
    chance1: 2,
    chance2: 0,
    inventoryWorth: 2250,
  },
  {
    itemId: 117,
    categoryId: 11,
    typeId: 7,
    categoryName: "Wrapped OGNFT",
    typeName: "7",
    chance1: 2,
    chance2: 0,
    inventoryWorth: 5250,
  },
  {
    itemId: 118,
    categoryId: 11,
    typeId: 8,
    categoryName: "Wrapped OGNFT",
    typeName: "10",
    chance1: 2,
    chance2: 0,
    inventoryWorth: 7500,
  },
  {
    itemId: 119,
    categoryId: 11,
    typeId: 9,
    categoryName: "Wrapped OGNFT",
    typeName: "10",
    chance1: 2,
    chance2: 0,
    inventoryWorth: 7500,
  },
  {
    itemId: 120,
    categoryId: 12,
    typeId: 0,
    categoryName: "Notification Credits",
    typeName: "1",
    chance1: 4,
    chance2: 0,
    inventoryWorth: 10,
  },
  {
    itemId: 121,
    categoryId: 12,
    typeId: 1,
    categoryName: "Notification Credits",
    typeName: "2",
    chance1: 4,
    chance2: 0,
    inventoryWorth: 25,
  },
  {
    itemId: 122,
    categoryId: 12,
    typeId: 2,
    categoryName: "Notification Credits",
    typeName: "3",
    chance1: 4,
    chance2: 0,
    inventoryWorth: 50,
  },
  {
    itemId: 123,
    categoryId: 12,
    typeId: 3,
    categoryName: "Notification Credits",
    typeName: "5",
    chance1: 4,
    chance2: 0,
    inventoryWorth: 100,
  },
  {
    itemId: 124,
    categoryId: 12,
    typeId: 4,
    categoryName: "Notification Credits",
    typeName: "10",
    chance1: 4,
    chance2: 0,
    inventoryWorth: 150,
  },
  {
    itemId: 125,
    categoryId: 12,
    typeId: 5,
    categoryName: "Notification Credits",
    typeName: "15",
    chance1: 4,
    chance2: 0,
    inventoryWorth: 200,
  },
  {
    itemId: 126,
    categoryId: 12,
    typeId: 6,
    categoryName: "Notification Credits",
    typeName: "25",
    chance1: 4,
    chance2: 0,
    inventoryWorth: 250,
  },
  {
    itemId: 127,
    categoryId: 12,
    typeId: 7,
    categoryName: "Notification Credits",
    typeName: "50",
    chance1: 4,
    chance2: 0,
    inventoryWorth: 300,
  },
  {
    itemId: 128,
    categoryId: 12,
    typeId: 8,
    categoryName: "Notification Credits",
    typeName: "75",
    chance1: 4,
    chance2: 0,
    inventoryWorth: 350,
  },
  {
    itemId: 129,
    categoryId: 12,
    typeId: 9,
    categoryName: "Notification Credits",
    typeName: "100",
    chance1: 4,
    chance2: 0,
    inventoryWorth: 500,
  },
  {
    itemId: 130,
    categoryId: 13,
    typeId: 0,
    categoryName: "Slot",
    typeName: null,
    chance1: 0,
    chance2: 0,
    inventoryWorth: 0,
  },
  {
    itemId: 140,
    categoryId: 14,
    typeId: 0,
    categoryName: "Business objects",
    typeName: "Jackpot",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 11000,
  },
  {
    itemId: 141,
    categoryId: 14,
    typeId: 1,
    categoryName: "Business objects",
    typeName: "Lottery Hall",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 11000,
  },
  {
    itemId: 150,
    categoryId: 15,
    typeId: 0,
    categoryName: "New Car",
    typeName: "Rolls-Royce 20/25 HP Standard Sedan - $125,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 225,
  },
  {
    itemId: 151,
    categoryId: 15,
    typeId: 1,
    categoryName: "New Car",
    typeName: "Rolls-Royce 20/25 HP Sports Saloon  - $175,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 300,
  },
  {
    itemId: 152,
    categoryId: 15,
    typeId: 2,
    categoryName: "New Car",
    typeName: "Rolls-Royce Phantom II  - $250,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 450,
  },
  {
    itemId: 153,
    categoryId: 15,
    typeId: 3,
    categoryName: "New Car",
    typeName: "Rolls-Royce Phantom II Continental Limousine  - $500,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 600,
  },
  {
    itemId: 154,
    categoryId: 15,
    typeId: 4,
    categoryName: "New Car",
    typeName: "Bentley 4.5 Litre Standard Tourer  - $100,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 200,
  },
  {
    itemId: 155,
    categoryId: 15,
    typeId: 5,
    categoryName: "New Car",
    typeName: "Bentley 4.5 Litre Sports Saloon  - $150,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 250,
  },
  {
    itemId: 156,
    categoryId: 15,
    typeId: 6,
    categoryName: "New Car",
    typeName: "Bentley Speed Six Saloon  - $200,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 300,
  },
  {
    itemId: 157,
    categoryId: 15,
    typeId: 7,
    categoryName: "New Car",
    typeName: "Bentley 8 Litre Limousine by H.J. Mulliner  - $450,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 550,
  },
  {
    itemId: 158,
    categoryId: 15,
    typeId: 8,
    categoryName: "New Car",
    typeName: "Packard Standard Eight Model 726  - $75,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 150,
  },
  {
    itemId: 159,
    categoryId: 15,
    typeId: 9,
    categoryName: "New Car",
    typeName: "Packard Standard Eight Model 733  - $125,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 225,
  },
  {
    itemId: 160,
    categoryId: 15,
    typeId: 10,
    categoryName: "New Car",
    typeName: "Packard Deluxe Eight Model 740  - $175,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 300,
  },
  {
    itemId: 161,
    categoryId: 15,
    typeId: 11,
    categoryName: "New Car",
    typeName: "Packard Custom Eight Model 745 Convertible Sedan  - $350,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 500,
  },
  {
    itemId: 162,
    categoryId: 15,
    typeId: 12,
    categoryName: "New Car",
    typeName: "Cadillac Series 353 Standard Sedan  - $70,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 140,
  },
  {
    itemId: 163,
    categoryId: 15,
    typeId: 13,
    categoryName: "New Car",
    typeName: "Cadillac Series 353 Town Sedan  - $120,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 220,
  },
  {
    itemId: 164,
    categoryId: 15,
    typeId: 14,
    categoryName: "New Car",
    typeName: "Cadillac V-16 Imperial Sedan  - $180,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 275,
  },
  {
    itemId: 165,
    categoryId: 15,
    typeId: 15,
    categoryName: "New Car",
    typeName: "Cadillac V-16 Roadster  - $275,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 460,
  },
  {
    itemId: 166,
    categoryId: 15,
    typeId: 16,
    categoryName: "New Car",
    typeName: "Lincoln Model L  - $60,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 140,
  },
  {
    itemId: 167,
    categoryId: 15,
    typeId: 17,
    categoryName: "New Car",
    typeName: "Lincoln Model K sedan  - $100,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 200,
  },
  {
    itemId: 168,
    categoryId: 15,
    typeId: 18,
    categoryName: "New Car",
    typeName: "Lincoln Model L Town Car  - $155,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 255,
  },
  {
    itemId: 169,
    categoryId: 15,
    typeId: 19,
    categoryName: "New Car",
    typeName: "Lincoln Model L Limousine  - $250,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 450,
  },
  {
    itemId: 170,
    categoryId: 15,
    typeId: 20,
    categoryName: "New Car",
    typeName: "Chrysler Model 66 sedan  - $40,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 115,
  },
  {
    itemId: 171,
    categoryId: 15,
    typeId: 21,
    categoryName: "New Car",
    typeName: "Chrysler Series 70 sedan  - $75,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 150,
  },
  {
    itemId: 172,
    categoryId: 15,
    typeId: 22,
    categoryName: "New Car",
    typeName: "Chrysler Imperial Model 80 Roadster  - $90,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 190,
  },
  {
    itemId: 173,
    categoryId: 15,
    typeId: 23,
    categoryName: "New Car",
    typeName: "Chrysler Imperial Custom Series 8 Limousine  - $150,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 250,
  },
  {
    itemId: 174,
    categoryId: 15,
    typeId: 24,
    categoryName: "New Car",
    typeName: "Buick Series 40  - $15,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 50,
  },
  {
    itemId: 175,
    categoryId: 15,
    typeId: 25,
    categoryName: "New Car",
    typeName: "Buick Series 50 sedan  - $35,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 100,
  },
  {
    itemId: 176,
    categoryId: 15,
    typeId: 26,
    categoryName: "New Car",
    typeName: "Buick Series 60 sedan  - $50,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 125,
  },
  {
    itemId: 177,
    categoryId: 15,
    typeId: 27,
    categoryName: "New Car",
    typeName: "Buick Series 90 Limited  - $100,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 200,
  },
  {
    itemId: 178,
    categoryId: 15,
    typeId: 28,
    categoryName: "New Car",
    typeName: "DeSoto Model K  - $16,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 55,
  },
  {
    itemId: 179,
    categoryId: 15,
    typeId: 29,
    categoryName: "New Car",
    typeName: "DeSoto CF Eight sedan  - $25,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 80,
  },
  {
    itemId: 180,
    categoryId: 15,
    typeId: 30,
    categoryName: "New Car",
    typeName: "DeSoto Deluxe Eight sedan  - $40,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 115,
  },
  {
    itemId: 181,
    categoryId: 15,
    typeId: 31,
    categoryName: "New Car",
    typeName: "DeSoto Custom Imperial Limousine  - $75,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 150,
  },
  {
    itemId: 182,
    categoryId: 15,
    typeId: 32,
    categoryName: "New Car",
    typeName: "Dodge DC Series sedan  - $16,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 55,
  },
  {
    itemId: 183,
    categoryId: 15,
    typeId: 33,
    categoryName: "New Car",
    typeName: "Dodge Eight Series DH sedan  - $25,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 80,
  },
  {
    itemId: 184,
    categoryId: 15,
    typeId: 34,
    categoryName: "New Car",
    typeName: "Dodge Senior Six sedan  - $35,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 100,
  },
  {
    itemId: 185,
    categoryId: 15,
    typeId: 35,
    categoryName: "New Car",
    typeName: "Dodge Deluxe Eight Limousine  - $75,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 150,
  },
  {
    itemId: 186,
    categoryId: 15,
    typeId: 36,
    categoryName: "New Car",
    typeName: "Hudson Greater Eight  - $8,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 30,
  },
  {
    itemId: 187,
    categoryId: 15,
    typeId: 37,
    categoryName: "New Car",
    typeName: "Hudson Essex Super Six  - $16,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 55,
  },
  {
    itemId: 188,
    categoryId: 15,
    typeId: 38,
    categoryName: "New Car",
    typeName: "Hudson Custom Eight  - $27,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 85,
  },
  {
    itemId: 189,
    categoryId: 15,
    typeId: 39,
    categoryName: "New Car",
    typeName: "Hudson Greater Eight Custom Limousine  - $50,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 125,
  },
  {
    itemId: 190,
    categoryId: 15,
    typeId: 40,
    categoryName: "New Car",
    typeName: "Nash 400 Series sedan  - $8,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 30,
  },
  {
    itemId: 191,
    categoryId: 15,
    typeId: 41,
    categoryName: "New Car",
    typeName: "Nash Standard Six sedan  - $16,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 55,
  },
  {
    itemId: 192,
    categoryId: 15,
    typeId: 42,
    categoryName: "New Car",
    typeName: "Nash Advanced Eight sedan  - $27,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 85,
  },
  {
    itemId: 193,
    categoryId: 15,
    typeId: 43,
    categoryName: "New Car",
    typeName: "Nash Ambassador Eight Limousine  - $50,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 125,
  },
  {
    itemId: 194,
    categoryId: 15,
    typeId: 44,
    categoryName: "New Car",
    typeName: "Studebaker Six Standard Sedan  - $8,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 30,
  },
  {
    itemId: 195,
    categoryId: 15,
    typeId: 45,
    categoryName: "New Car",
    typeName: "Studebaker Commander Sedan  - $16,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 55,
  },
  {
    itemId: 196,
    categoryId: 15,
    typeId: 46,
    categoryName: "New Car",
    typeName: "Studebaker President Eight Sedan  - $27,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 85,
  },
  {
    itemId: 197,
    categoryId: 15,
    typeId: 47,
    categoryName: "New Car",
    typeName: "Studebaker President Convertible Coupe  - $50,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 125,
  },
  {
    itemId: 198,
    categoryId: 15,
    typeId: 48,
    categoryName: "New Car",
    typeName: "Ford Model A  - $5,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 20,
  },
  {
    itemId: 199,
    categoryId: 15,
    typeId: 49,
    categoryName: "New Car",
    typeName: "Ford Model A Deluxe Roadster  - $12,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 45,
  },
  {
    itemId: 200,
    categoryId: 15,
    typeId: 50,
    categoryName: "New Car",
    typeName: "Ford Model A Town Car  - $21,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 75,
  },
  {
    itemId: 201,
    categoryId: 15,
    typeId: 51,
    categoryName: "New Car",
    typeName: "Ford Model A Tudor Limousine  - $42,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 120,
  },
  {
    itemId: 202,
    categoryId: 15,
    typeId: 52,
    categoryName: "New Car",
    typeName: "Chevrolet Universal Series AD Coach  - $5,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 20,
  },
  {
    itemId: 203,
    categoryId: 15,
    typeId: 53,
    categoryName: "New Car",
    typeName: "Chevrolet Independence Series AE sedan  - $12,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 45,
  },
  {
    itemId: 204,
    categoryId: 15,
    typeId: 54,
    categoryName: "New Car",
    typeName: "Chevrolet Series AD Universal Phaeton  - $21,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 75,
  },
  {
    itemId: 205,
    categoryId: 15,
    typeId: 55,
    categoryName: "New Car",
    typeName: "Chevrolet Series AD Universal Landau  - $42,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 120,
  },
  {
    itemId: 206,
    categoryId: 15,
    typeId: 56,
    categoryName: "New Car",
    typeName: "Austin 7  - $5,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 20,
  },
  {
    itemId: 207,
    categoryId: 15,
    typeId: 57,
    categoryName: "New Car",
    typeName: "Austin 12/4  - $12,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 45,
  },
  {
    itemId: 208,
    categoryId: 15,
    typeId: 58,
    categoryName: "New Car",
    typeName: "Austin 16  - $15,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 50,
  },
  {
    itemId: 209,
    categoryId: 15,
    typeId: 59,
    categoryName: "New Car",
    typeName: "Austin 20/6 Mayfair Limousine  - $37,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 105,
  },
  {
    itemId: 210,
    categoryId: 15,
    typeId: 60,
    categoryName: "New Car",
    typeName: "Plymouth Model U  - $5,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 20,
  },
  {
    itemId: 211,
    categoryId: 15,
    typeId: 61,
    categoryName: "New Car",
    typeName: "Plymouth 30U sedan  - $12,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 45,
  },
  {
    itemId: 212,
    categoryId: 15,
    typeId: 62,
    categoryName: "New Car",
    typeName: "Plymouth PA Deluxe sedan  - $15,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 50,
  },
  {
    itemId: 213,
    categoryId: 15,
    typeId: 63,
    categoryName: "New Car",
    typeName: "Plymouth PA Deluxe Limousine  - $37,000",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 105,
  },
  {
    itemId: 214,
    categoryId: 16,
    typeId: 0,
    categoryName: "FBI Assets",
    typeName: "FBI Training pass",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 1000,
  },
  {
    itemId: 215,
    categoryId: 16,
    typeId: 1,
    categoryName: "FBI Assets",
    typeName: "Detective badge",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 2000,
  },
  {
    itemId: 216,
    categoryId: 16,
    typeId: 2,
    categoryName: "FBI Assets",
    typeName: "Special Agent badge",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 3000,
  },
  {
    itemId: 217,
    categoryId: 16,
    typeId: 3,
    categoryName: "FBI Assets",
    typeName: "Field office business",
    chance1: 0,
    chance2: 0,
    inventoryWorth: 15000,
  },
];
